import cls from "classnames";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserApiAccessFormData } from "../types";
// components
import { Button, Form, Input, Select } from "antd";

export const Step3Form: React.FC<{
  data: UserApiAccessFormData;
  visible: boolean;
  onPrev: () => void;
  onNext: (data: UserApiAccessFormData) => void;
  onCancel: () => void;
}> = ({ data, visible, onPrev, onNext, onCancel }) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<UserApiAccessFormData>();

  const [apiAccessMode, setApiAccessMode] = useState<number>(
    data.api_access_mode
  );

  const handleApiAccessModeChange = (value: number) => {
    setApiAccessMode(value);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      className={cls(["mt:16", { hidden: !visible }])}
      onFinish={(values) => {
        onNext(values);
      }}
    >
      <Form.Item
        label={t("systems.Extra.mode")}
        colon={false}
        required={false}
        className="flex:1"
        name="api_access_mode"
      >
        <Select onChange={handleApiAccessModeChange}>
          <Select.Option value={0}>
            {t("systems.Extra.whiteList")}
          </Select.Option>
          <Select.Option value={1}>
            {t("systems.Extra.blackList")}
          </Select.Option>
        </Select>
      </Form.Item>

      {apiAccessMode === 0 && (
        <div>
          <h3 className="mb:12 t:center">{t("systems.Extra.whiteList")}</h3>

          <Form.Item
            label={t("domains.Tenant.basicFunctions")}
            name="api_white_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label={t("domains.Tenant.withdrawFunctions")}
            name="api_member_withdraw_white_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label={t("domains.Tenant.depositFunctions")}
            name="api_member_deposit_white_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      {apiAccessMode === 1 && (
        <div>
          <h3 className="mb:12 t:center">{t("systems.Extra.blackList")}</h3>

          <Form.Item
            label={t("domains.Tenant.basicFunctions")}
            name="api_black_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label={t("domains.Tenant.withdrawFunctions")}
            name="api_member_withdraw_black_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>

          <Form.Item
            label={t("domains.Tenant.depositFunctions")}
            name="api_member_deposit_black_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      <Form.Item>
        <div className="flex jc:end gap:8">
          <Button htmlType="button" onClick={onCancel}>
            {t("systems.Action.cancel")}
          </Button>
          <Button htmlType="button" onClick={onPrev}>
            {t("systems.Action.prev")}
          </Button>
          <Button type="primary" htmlType="submit">
            {t("systems.Action.next")}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
